// import React, { useState,useRef,useEffect } from 'react';
// import { useForm } from "react-hook-form";
// import ReCAPTCHA from "react-google-recaptcha";
// import HCaptcha from '@hcaptcha/react-hcaptcha';
import { AppWrap, MotionWrap } from '../../wrapper';
// import { client } from '../../client';
import './Footer.scss';

const Footer = () => {
  // const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  // const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  // const [loading, setLoading] = useState(false);

  // const { username, email, message } = formData;

  // const handleChangeInput = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({ ...formData, [name]: value });
  // };
  // //captcha
  // const [token, setToken] = useState(null);
  // const captchaRef = useRef(null);
  // let isVerified =false;
  // useEffect(() => {

  //   if (token){
  //     console.log(`hCaptcha Token: ${token}`);
        
  //   }

  // }, [token]);
  // const handleSubmit = () => {
  //   if (!token) {
  //     captchaRef.current.execute();
  //    }
  //    if(token){
  //     isVerified=true;
  //    };
  //   if(isVerified===true){
  //   setLoading(true);

  //   const contact = {
  //     _type: 'contact',
  //     name: formData.username,
  //     email: formData.email,
  //     message: formData.message,
  //   };

  //   client.create(contact)
  //     .then(() => {
  //       setLoading(false);
  //       setIsFormSubmitted(true);
  //     })
  //     .catch((err) => console.log(err));
  //   }
  // };

  return (
    <>
      {/* <h2 className="head-text">Vous <span>voulez</span> me contacter <span>?</span></h2> */}
      {/* {!isFormSubmitted ? (
        <form className="app__footer-form app__flex" name='contact v1' method="POST" data-netlify="true">
          <input type="hidden" name="form-name" value="contact v1" />
          <div className="app__flex div-form"> 
            <input className="p-text" type="text" placeholder="Votre Nom" name="username" value={username} onChange={handleChangeInput} />
          </div>
          <div className="app__flex div-form">
            <input className="p-text" type="email" placeholder="Votre Email" name="email" value={email} onChange={handleChangeInput} />
          </div>
          <div className='div-form'>
            <textarea
              className="p-text"
              placeholder="Votre Message"
              value={message}
              name="message"
              onChange={handleChangeInput}
            />
          </div>
            <HCaptcha
            sitekey={process.env.REACT_APP_CAPTCHA_PUBLIC}
            onVerify={setToken}
            ref={captchaRef}
            />
          <button type="submit" className="p-text" onClick={handleSubmit}>{!loading ? 'Send Message' : 'Sending...'}</button>
        </form>
        ) : (
          <div>
            <h3 className="head-text submit-text">
              Merci, je vous <span> contacterai</span> dès que <span> possible</span> !
            </h3>
          </div>
        )} */}
        <h2 className="head-text">Vous <span>voulez</span> me contacter <span>?</span></h2>
        <form className="app__footer-form app__flex" name='Contact' method="POST" data-netlify="true">
          <input type="hidden" name="form-name" value="Contact" />
          <input className='app_footer-hidden' name="bot-field" />
          <div className="app__flex div-form">
            <input className="p-text" type="text" placeholder="Votre Nom" name="username" />
          </div>
          <div className="app__flex div-form">
            <input className="p-text" type="email" placeholder="Votre Email" name="email" />
          </div>
          <div className='div-form'>
          <textarea
            className="p-text"
            placeholder="Votre Message"
            name="message"
          ></textarea>
          </div>
        <button type="submit" className="p-text">Envoyer</button>
        </form>
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__whitebg',
);
